import React from "react";
import {
  ATTENDANCE_VIEW_YEARLY_CARD_HEAD_CLASS,
  ATTENDANCE_VIEW_YEARLY_MONTH_BAR_AREA_CLASS,
  ATTENDANCE_VIEW_YEARLY_MONTH_BAR_TRACK_CLASS,
  ATTENDANCE_VIEW_YEARLY_MONTH_ITEM_CLASS,
  ATTENDANCE_VIEW_YEARLY_MONTH_LABEL_BASE_CLASS,
  getAttendanceViewYearlyAvgTextClass,
  getAttendanceViewYearlyBarTheme,
  getAttendanceViewYearlyCardClass,
  getAttendanceViewYearlyGridClass,
} from "./attendanceViewStyles";

export default function AttendanceYearlyView({
  animateChart,
  filteredStudents,
  handleYearMonthClick,
  isMobile,
  yearlyData,
}) {
  return (
    <div className={getAttendanceViewYearlyGridClass(isMobile)}>
      {filteredStudents.map((student) => {
        const data = yearlyData[student.id] || {};
        const rates = Object.values(data);
        const avg = rates.length > 0 ? Math.round(rates.reduce((a, b) => a + b, 0) / rates.length) : 0;

        return (
          <div key={student.id} className={getAttendanceViewYearlyCardClass(isMobile)}>
            <div className={ATTENDANCE_VIEW_YEARLY_CARD_HEAD_CLASS}>
              <div className="flex items-center gap-3">
                {student.photoUrl ? (
                  <img src={student.photoUrl} alt="" className="w-12 h-12 rounded-[1.2rem] object-cover border-2 border-white shadow-md group-hover:scale-105 transition-transform" />
                ) : (
                  <div className="w-12 h-12 rounded-[1.2rem] flex items-center justify-center shadow-md border-2 border-white group-hover:scale-105 transition-transform bg-white overflow-hidden">
                    <img src={student.gender === "남" ? "/images/boy_3d_light.png" : student.gender === "여" ? "/images/girl_3d_light.png" : "/images/boy_3d_light.png"} alt="avatar" className="w-full h-full object-cover transform scale-110" />
                  </div>
                )}
                <div>
                  <h4 className="font-black text-gray-800 text-lg leading-tight">{student.name}</h4>
                  <div className="flex gap-1 mt-0.5">
                    <span className="text-[10px] font-bold bg-gray-100 text-gray-500 px-1.5 py-0.5 rounded">{student.grade}</span>
                    <span className="text-[10px] font-bold bg-gray-100 text-gray-500 px-1.5 py-0.5 rounded">{student.class}</span>
                  </div>
                </div>
              </div>
              <div className="flex flex-col items-end">
                <span className="text-[10px] font-bold text-gray-400 mb-0.5">연간 평균</span>
                <span className={getAttendanceViewYearlyAvgTextClass(avg)}>{avg}%</span>
              </div>
            </div>

            <div className={ATTENDANCE_VIEW_YEARLY_MONTH_BAR_AREA_CLASS}>
              {[...Array(12)].map((_, i) => {
                const month = i + 1;
                const rate = data[month] || 0;
                const { barColor, textColor } = getAttendanceViewYearlyBarTheme(rate);

                return (
                  <div key={month} className={ATTENDANCE_VIEW_YEARLY_MONTH_ITEM_CLASS} onClick={() => handleYearMonthClick(month)} title={`${month}월 출석률: ${rate}%`}>
                    <div className={ATTENDANCE_VIEW_YEARLY_MONTH_BAR_TRACK_CLASS}>
                      <div className={`w-full rounded-t-lg rounded-b-md transition-all duration-1000 ease-out ${barColor}`} style={{ height: animateChart ? `${rate}%` : "0%" }}></div>
                    </div>
                    <span className={`${ATTENDANCE_VIEW_YEARLY_MONTH_LABEL_BASE_CLASS} ${textColor}`}>{month}</span>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
